import React from "react"

import { Button as MuiButton, styled } from "@mui/material"

const StyledButton = styled(MuiButton)(() => ({
  textWrap: "nowrap",
  lineHeight: 1.2,
  paddingBottom: "11px",
}))

// TODO _ typer + valeurs par defaut
const Button = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>
}

export default Button
